module.exports = __webpack_public_path__ + "img/DlawarQaradaghy-ChwarmexaKeshanawayMasih.b71d35b7.jpg";